// Transaction Details Actions
export const SET_PROMOS_TRANSACTION_DETAILS = 'SET_PROMOS_TRANSACTION_DETAILS';
export const SET_PETTY_CASH_TRANSACTION_DETAILS = 'SET_PETTY_CASH_TRANSACTION_DETAILS';
export const SET_TOURNAMENT_HOUSE_TRANSACTION_DETAILS = 'SET_TOURNAMENT_HOUSE_TRANSACTION_DETAILS';
export const ADD_PROMOS_TRANSACTION_DETAIL = 'ADD_PROMOS_TRANSACTION_DETAIL';
export const ADD_PETTY_CASH_TRANSACTION_DETAIL = 'ADD_PETTY_CASH_TRANSACTION_DETAIL';
export const ADD_TOURNAMENT_HOUSE_TRANSACTION_DETAIL = 'ADD_TOURNAMENT_HOUSE_TRANSACTION_DETAIL';
export const UPDATE_PROMOS_TRANSACTION_DETAIL = 'UPDATE_PROMOS_TRANSACTION_DETAIL';
export const UPDATE_PETTY_CASH_TRANSACTION_DETAIL = 'UPDATE_PETTY_CASH_TRANSACTION_DETAIL';
export const UPDATE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL = 'UPDATE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL';
export const DELETE_PROMOS_TRANSACTION_DETAIL = 'DELETE_PROMOS_TRANSACTION_DETAIL';
export const DELETE_PETTY_CASH_TRANSACTION_DETAIL = 'DELETE_PETTY_CASH_TRANSACTION_DETAIL';
export const DELETE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL = 'DELETE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL';

// Action Creators
export const setPromosTransactionDetails = (details) => ({
  type: SET_PROMOS_TRANSACTION_DETAILS,
  payload: details
});

export const setPettyCashTransactionDetails = (details) => ({
  type: SET_PETTY_CASH_TRANSACTION_DETAILS,
  payload: details
});

export const setTournamentHouseTransactionDetails = (details) => ({
  type: SET_TOURNAMENT_HOUSE_TRANSACTION_DETAILS,
  payload: details
});

export const addPromosTransactionDetail = (detail) => ({
  type: ADD_PROMOS_TRANSACTION_DETAIL,
  payload: detail
});

export const addPettyCashTransactionDetail = (detail) => ({
  type: ADD_PETTY_CASH_TRANSACTION_DETAIL,
  payload: detail
});

export const addTournamentHouseTransactionDetail = (detail) => ({
  type: ADD_TOURNAMENT_HOUSE_TRANSACTION_DETAIL,
  payload: detail
});

export const updatePromosTransactionDetail = (index, detail) => ({
  type: UPDATE_PROMOS_TRANSACTION_DETAIL,
  payload: { index, detail }
});

export const updatePettyCashTransactionDetail = (index, detail) => ({
  type: UPDATE_PETTY_CASH_TRANSACTION_DETAIL,
  payload: { index, detail }
});

export const updateTournamentHouseTransactionDetail = (index, detail) => ({
  type: UPDATE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL,
  payload: { index, detail }
});

export const deletePromosTransactionDetail = (index) => ({
  type: DELETE_PROMOS_TRANSACTION_DETAIL,
  payload: index
});

export const deletePettyCashTransactionDetail = (index) => ({
  type: DELETE_PETTY_CASH_TRANSACTION_DETAIL,
  payload: index
});

export const deleteTournamentHouseTransactionDetail = (index) => ({
  type: DELETE_TOURNAMENT_HOUSE_TRANSACTION_DETAIL,
  payload: index
});
